// routes
import { paths } from "src/routes/paths";

// API
// ----------------------------------------------------------------------

export const HOST_API = import.meta.env.VITE_HOST_API || "http://127.0.0.1:8000";;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.users.root;

export const PASSWORD_SPECIAL_CHARS = "!#%&:;<>=@_^";

export const USE_MOCK_DATA = false;
